export default __webpack_public_path__ + "static/media/tour_menu.8af9cde3.png";